import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';

import { BaseFieldControlComponent } from '@d-components/base-field-control/base-field-control';
import { BaseLabelComponent } from '@d-components/label/label.component';

@Component({
  selector: 'app-base-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextareaModule,
    CommonModule,
    BaseLabelComponent,
    TranslateModule,
    TooltipModule,
  ],
})
export class BaseTextareaComponent
  extends BaseFieldControlComponent
  implements OnInit
{
  @Input() lineNumber: number = 4;
  @Input() maxLength!: number;
  @Input() autoResize!: boolean;
  @Input() labelShowsOptional = false;
  @Input() hideLengthLimit = false;
  @Input() instructionText = '';
  @Input() tooltip = '';
  currentLength: number = 0;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.currentLength = this.fieldControl.value?.length || 0;
    this.fieldControl.valueChanges.subscribe((val: string) => {
      this.currentLength = val?.length || 0;
    });

    if (this.maxLength > 500 || !this.maxLength) this.maxLength = 500;
  }
}
